import { toast } from '@buffer-mono/popcorn'

import { postPermalinkRoute } from '~publish/legacy/routes'

/** Carries only the post id, so the link survives the post changing state. */
const getPostShareLink = (postId: string): string =>
  `${window.location.origin}${postPermalinkRoute.getRoute({ postId })}`

/**
 * The confirmation names the access rule because the link is not a capability —
 * people reasonably assume sharing a link shares the thing.
 */
export const copyPostPermalinkToClipboard = async (
  postId: string,
): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(getPostShareLink(postId))
    toast.success('Post link copied', {
      description: 'Only people with access to this channel can open it.',
    })
    return true
  } catch {
    toast.error('Unable to copy link')
    return false
  }
}
